export const FormatsData: import('../../../sim/dex-species').ModdedSpeciesFormatsDataTable = {
	venusaur: {
		tier: "OU",
	},
	raichu: {
		tier: "PU",
	},
	golbat: {
		tier: "NFE",
	},
	vileplume: {
		tier: "NU",
	},
	dugtrio: {
		tier: "OU",
	},
	primeape: {
		tier: "RU",
	},
	cloyster: {
		tier: "OU",
	},
	electrode: {
		tier: "PU",
	},
	marowak: {
		tier: "NU",
	},
	chansey: {
		tier: "OU",
	},
	kangaskhan: {
		tier: "PU",
	},
	electabuzz: {
		tier: "PU",
	},
	lapras: {
		tier: "PU",
	},
	ditto: {
		tier: "PU",
	},
	vaporeon: {
		tier: "OU",
	},
	jolteon: {
		tier: "OU",
	},
	flareon: {
		tier: "NU",
	},
	ampharos: {
		tier: "PU",
	},
	quagsire: {
		tier: "NU",
	},
	espeon: {
		tier: "OU",
	},
	donphan: {
		tier: "OU",
	},
	linoone: {
		tier: "PU",
	},
	vigoroth: {
		tier: "NFE",
	},
	roselia: {
		tier: "RU",
	},
	zangoose: {
		tier: "PU",
	},
	cradily: {
		tier: "PU",
	},
	absol: {
		tier: "NU",
	},
	froslass: {
		tier: "UU",
	},
	metagross: {
		tier: "OU",
	},
	regice: {
		tier: "PU",
	},
	deoxysdefense: {
		tier: "UUBL",
	},
	torterra: {
		tier: "NU",
	},
	infernape: {
		tier: "OU",
	},
	luxray: {
		tier: "NU",
	},
	garchomp: {
		tier: "Uber",
	},
	lucario: {
		tier: "OU",
	},
	hippowdon: {
		tier: "UUBL",
	},
	toxicroak: {
		tier: "OU",
	},
	snover: {
		tier: "UUBL",
	},
	abomasnow: {
		tier: "UUBL",
	},
	magmortar: {
		tier: "NU",
	},
	leafeon: {
		tier: "NU",
	},
	porygonz: {
		tier: "RUBL",
	},
	rotomfrost: {
		tier: "PU",
	},
	emboar: {
		tier: "NU",
	},
	stoutland: {
		tier: "UU",
	},
	liepard: {
		tier: "PU",
	},
	simipour: {
		tier: "PU",
	},
	gigalith: {
		tier: "PU",
	},
	excadrill: {
		tier: "Uber",
	},
	seismitoad: {
		tier: "PU",
	},
	throh: {
		tier: "PU",
	},
	scolipede: {
		tier: "RU",
	},
	basculin: {
		tier: "NU",
	},
	scrafty: {
		tier: "OU",
	},
	cofagrigus: {
		tier: "RU",
	},
	carracosta: {
		tier: "PU",
	},
	cinccino: {
		tier: "NU",
	},
	gothorita: {
		tier: "NFE",
	},
	gothitelle: {
		tier: "PU",
	},
	swanna: {
		tier: "PU",
	},
	escavalier: {
		tier: "UU",
	},
	amoongus: {
		tier: "NU",
	},
	chandelure: {
		tier: "UU",
	},
	haxorus: {
		tier: "OU",
	},
	cryogonal: {
		tier: "NU",
	},
	mienshao: {
		tier: "OU",
	},
	golurk: {
		tier: "RU",
	},
	mandibuzz: {
		tier: "RU",
	},
	durant: {
		tier: "RUBL",
	},
	hydreigon: {
		tier: "OU",
	},
	virizion: {
		tier: "OU",
	},
	tornadus: {
		tier: "OU",
	},
	tornadustherian: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	thundurustherian: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	landorus: {
		tier: "OU",
	},
	landorustherian: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	kyuremblack: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	kyuremwhite: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	keldeo: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	keldeoresolute: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	meloetta: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	genesect: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
};
